<template>
	<div class="">
		<div class="flex justify-between py-2 my-2 text-sm">
			<div class="flex">
				<!-- <div class="ml-1 flex items-center">
					<div class="w-3 h-3 rounded-full border border-transparent bg-red-400 ml-1"></div>
					<span class="ml-1">new</span>
				</div>
				<div class="ml-1 flex items-center">
					<div class="w-3 h-3 rounded-full border border-red-400 ml-1"></div>
					<span class="ml-1">processing</span>
				</div> -->
				<!-- <div class="ml-1 flex items-center">
					<div class="w-3 h-3 rounded-full border border-transparent bg-yellow-500 ml-1"></div>
					<span class="ml-1">problem</span>
				</div> -->
				<!-- <div class="ml-1 flex items-center">
					<div class="w-3 h-3 rounded-full border border-transparent bg-gray-300 ml-1"></div>
					<span class="ml-1">complete</span>
				</div> -->
			</div>
			<div class="flex space-x-4">
				<label class="flex items-center space-x-2">
					<input type="checkbox" id="vat" class="form-checkbox h-4 w-4 text-gray-400" v-model="showOrderReceived">
					<span>show complete</span>
				</label>
				<router-link class="flex justify-center px-4 py-2 text-lg rounded border hover:bg-gray-50" :to="`/forecasts/${regionid}/history`" title="View" v-if="! isReticulation">
					History
				</router-link>
				<button class="flex items-center whitespace-nowrap space-x-2  px-4 py-2 text-lg rounded px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white" @click="bulkorder.show = !bulkorder.show" v-if="Object.keys(forecasts).length && ! isReticulation">
					<plus-icon class="w-5 h-5"></plus-icon>
					<span>Bulk order</span>
				</button>
				<router-link class="flex justify-center text-white bg-green-600 px-4 py-2 text-lg rounded hover:bg-green-700" :to="`/forecasts/${regionid}/review`" title="View" v-if="! isReticulation">
					Review
				</router-link>
			</div>
		</div>
		<div v-if="loading" class="text-grey-darker">
			Loading...
		</div>
		<div v-else-if="!Object.keys(forecasts).length" class="text-grey-darker px-2">
			No <span v-text="isReticulation ? `Reticulation` : `Forecast`"></span> Orders
		</div>
		<div v-else>
			<div v-for="(job) in filteredForecasts">
				<div class="pb-1">
					<div class="p-2 bg-gray-200 mb-1" :class="[job.modified ? 'bg-yellow-100' : '', job.complete ? 'bg-green-100' : '']">
						<div class="flex items-center justify-between" v-if="isReticulation">
							<router-link class="flex items-center justify-between w-full" :to="`/job/${job.job_id}/${$route.params.type}/${job.area_id}/process`" title="View" v-if="isReticulation">
								<h2 class="ml-2 text-lg font-normal text-gray-700 sm:ml-4">{{ job.name }}</h2>
							</router-link>
							<div class="flex items-center space-x-2">
								<router-link class="btn text-gray-700" :to="`/forecasts/${ordernumber}/breakdown`" title="View" v-if="isReticulation" v-for="ordernumber in job.forecastOrderNumbers" :key="`fc-${ordernumber}`">{{ ordernumber }}</router-link>
							</div>							
						</div>
						<router-link class="flex items-center" :to="`/job/${job.job_id}/${$route.params.type}/process`" title="View" v-else>
							<h2 class="ml-2 text-lg font-normal text-gray-700 sm:ml-4">{{ job.name }}</h2>
						</router-link>
					</div>							
				</div>
			</div>
			<!-- <div class="flex justify-between items-center p-4 bg-gray-200 mb-2" v-for="order in reticulationForecasts" :key="order.id" v-if="order.length">
				<router-link class="flex items-center uppercase" :to="`/forecast/${regionid}/orders/${order.delivery_date}/${order.type}`" title="View">
					<div class="w-3 h-3 rounded-full border" :class="`${order.status}Class`"></div>
					<h2 class="ml-2 text-lg font-normal text-gray-700 sm:ml-4">{{ pad(order.reference_id,3) }}</h2>
                    <h3 v-if="order.type=='emergency'" class="ml-2 border-2 rounded-full border-red-400 text-red-400 text-xs px-1 py-1">Emergency</h3>
					<h3 v-if="order.type=='reticulation_cable'" class="ml-2 border-2 rounded-full border-green-800 text-green-800 text-xs px-1 py-1">Cable</h3>
				</router-link>						
				<div class="flex-1 flex justify-end items-center text-sm ml-2 sm:ml-10">
					<div class="ml-4">
						{{ order.created_at}}
					</div>
				</div>
			</div> -->				
		</div>
		<portal to="modals" v-if="bulkorder.show" :order="1">
			<bulk-order-modal
				:show="bulkorder.show"			
				:regionid="regionid"
				@close="bulkorder.show = false"
				@save="saveBulkOrder"
				@reload="$emit('reload')"
				>
			</bulk-order-modal>
		</portal>
	</div>
</template>

	<script>
		import BulkOrderModal from '../../components/common/BulkOrderModal.vue'
		import { MenuIcon } from 'vue-feather-icons'
		export default {
			name: 'ForecastRegionListing',
			data () {
				return {
					regionid: this.$route.params.regionid,
					isReticulation: this.$route.params.type == 'reticulation',
					forecasts: [],
					loading: true,
					expand: null,
					regions: ['Gauteng','KwaZulu-Natal','Cape Town'],
					bulkorder: {
						show: false
					},
					showOrderReceived: false,
				}
			},
			components: {
				MenuIcon,
				BulkOrderModal
			},
			computed: {
				filteredForecasts: function(){
					let filtered = this.forecasts;
					if(this.isReticulation){
						filtered = this.forecasts.filter(fc => {
							if(! this.showOrderReceived){
								return fc.complete == false;
							}
							return true;
						})						
					}	
					return filtered;
				},
				fetchUrl: function(){
					let path = this.isReticulation ? `reticulation` : `orders`
					let url = `forecasts/${this.$route.params.regionid}/${path}`;
					return url;
				},
				allOrders: function(){
					if(!this.forecasts.length) return [];
					let reFormed = {};
					this.forecasts.forEach(forecast => {
						if(forecast.type == 'normal'){
							if(!reFormed.hasOwnProperty(forecast.delivery_date)){
								reFormed[forecast.delivery_date] = [];
							}
							reFormed[forecast.delivery_date].push(forecast);
						}else{
							if(!reFormed.hasOwnProperty(forecast.type)){
								reFormed[forecast.type] = [];
							}
							reFormed[forecast.type].push(forecast);
						}
					});
					return reFormed;			
				},
				// forecasts: function () {
				// 	if(!this.forecasts.length) return [];
				// 	return this.$_.groupBy(this.forecasts, 'region');
				// },
				// reticulationForecasts: function () {
				// 	if(!this.forecasts.length) return [];
				// 	return this.$_.filter(this.forecasts, {'type': 'reticulation_cable'});
				// }
			},
			methods: {
				toggleExpand: function(region){
					this.expand = this.expand == null ? region : null;
				},
				saveBulkOrder: function (data) {
					console.log(data);
				}
			},
			created () {
				this.$store.commit('setJobName', null)
				this.$http.get(this.fetchUrl)
				.then((response) => {
					this.forecasts = response.data.forecasts ? response.data.forecasts : [];
				})
				.then(() => {
					this.loading = false;
				})
			}
		}
	</script>
	<style lang="css" scoped>
	.orderedClass {
		@apply border-transparent bg-red-400;
	}
	.problemClass {
		@apply border-transparent bg-yellow-500;
	}
	.receivedClass {
		@apply rounded-full bg-green-500 text-white;
	}
	.completeClass, processedClass  {
		@apply border-transparent bg-gray-300;
	}
</style>